import { Outlet } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import Background from '../assets/img/background.png';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    margin: 0,
    height: '100vh',
    overflow: 'auto',
    width: '100%',
    color: theme.palette.background.card,
    backgroundImage: `linear-gradient( rgba(8, 8, 67, 0.65), rgba(0, 15, 70, 0.575)), url(${Background})`,
  },
}));

function AuthLayout() {
  const classes = useStyles();

  return (
    <Grid className={classes.root}>
      <Grid
        className={classes.container}
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item md={8} xs={6} container />
        <Grid item md={4} xs={4}>
          {' '}
          <Outlet />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AuthLayout;
